import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Filters } from "./styles";
import { Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Main from "../../../../layout/main/Main";
import { COLORS, Typo } from "../../../../layout/theme";
import DataTable from "../../../../common/data-table/DataTable";
import { useAuth } from "../../../../../contexts/authContext";
import SignInTemplate from "../../../../layout/sign-in-template/SignInTemplate";
import DropShadow from "../../../../common/drop-shadow/DropShadow";
import { get_agent_configs_page } from "../../../../../api/endpoints/agents";

export default function AgentConfigsList({ clientId }) {
	const navigate = useNavigate();
	const { userdata } = useAuth();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [data, setData] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [key, setKey] = useState("null");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Nombre</div>,
			dataIndex: "name",
			width: 300,
			render: (value, record) => (
				<Link
					to={`/admin/agentConfigs/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="secondary" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</Link>
			),
		},
	];

	const fetch_data_agent_clients = async (page, search) => {
		const res = await get_agent_configs_page(search, state, page);
		setData(res);
	};

	useEffect(() => {
		fetch_data_agent_clients(1, clientId);
	}, [state]);

	return (
		<Main>
			<Main.Breadcrumb>
				<Main.BreadcrumbItem>
					{uri ? (
						<Link to={"/" + uri}>Configuración General</Link>
					) : (
						<Link to="/">Home</Link>
					)}
				</Main.BreadcrumbItem>
				<Main.BreadcrumbSeparator />
				<Main.ActiveBreadcrumbItem>
					Listado de clientes
				</Main.ActiveBreadcrumbItem>
			</Main.Breadcrumb>

			<Main.Body>
				<Filters>
					<Space size="large">
						{userdata.isOneMarket && data?.items?.length === 0 && (
							<DropShadow type="drop">
								<SignInTemplate.AntdButton
									type="primary"
									bg="Primary"
									color="White"
									icon={<PlusOutlined />}
									onClick={() =>
										navigate("/admin/agentConfigs/create?uri=" + uri)
									}
									style={{ width: "200px", fontWeight: "400" }}
								>
									Crear Configuracion
								</SignInTemplate.AntdButton>
							</DropShadow>
						)}
					</Space>
				</Filters>
				<DataTable
					data={data}
					fetch={fetch_data_agent_clients}
					columns={columns}
				/>
			</Main.Body>
		</Main>
	);
}
